
<div *ngIf="!containsError">
  <div>
       <span class="pageHeader">
									{{transactionHeader}}
       </span>
  </div>

  <br><br>

  <div class="bodyAlign">
    <hr class="hrStyle">
    <div class="ui-g">
      <div type="button" class="ui-g-4 labFon glypha-font" (click)="displayTransactionBody('Unscheduled')"> Unscheduled</div>
      <div type="button" class="ui-g-4 labFon glypha-font" (click)="displayTransactionBody('partpayment')"> Partial Prepayment</div>
      <div type="button" class="ui-g-4 labFon glypha-font" (click)="displayTransactionBody('loanStatusMaintne')"> Loan Status Maintenance
      </div>
    </div>
    <div class="ui-g">
      <div type="button" class="ui-g-4 labFon glypha-font" (click)="displayTransactionBody('paymentChange')">Payment Change</div>
      <div type="button" class="ui-g-4 labFon glypha-font" (click)="displayTransactionBody('loanPayOff')"> Loan Payoff</div>
      <div type="button" class="ui-g-4 labFon glypha-font" (click)="displayTransactionBody('serviceTransfer')"> Servicer Transfer</div>
    </div>
    <div class="ui-g">
      <div type="button" class="ui-g-3 labFon glypha-font" (click)="displayTransactionBody('calLoanPayOff')">Calculate Loan Payoff
      </div>
    </div>
    <hr class="hrStyle">
  </div>

  <br>
  <div *ngIf="isLoanPayOff">
    <app-loanpayoff></app-loanpayoff>
  </div>
  <div *ngIf="isCalLoanPayOff">
    <app-calculate-loan-pay-off></app-calculate-loan-pay-off>
  </div>
  <div *ngIf="isunshedPageOff">
    <app-unscheduled></app-unscheduled>
  </div>
  <div *ngIf="isPartPmnt">
    <app-partpayment></app-partpayment>
  </div>
  <div *ngIf="isServiceTransfer">
    <app-servicetransfer></app-servicetransfer>
  </div>
  <div *ngIf="isLoanStatusMaintne">
    <app-loanStatusMaintne></app-loanStatusMaintne>
  </div>
  <div *ngIf="isPaymentChange">
    <app-paymentChange></app-paymentChange>
  </div>
</div>
